'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visitorReceiveHandlers = undefined;

var _VisitorActionTypes = require('../../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _messageTypeComparators = require('conversations-schema/pubnub-message/operators/messageTypeComparators');

var _commonMessageFormatGetters = require('conversations-schema/common-message-format/operators/commonMessageFormatGetters');

var _getActiveChannel = require('../../selectors/clientSelectors/getActiveChannel');

var _hasNewUnseenMessage = require('../../last-seen/actions/hasNewUnseenMessage');

var _addMessageToConversation = require('../../actions/ConversationsActions/addMessageToConversation');

var _getIsOpen = require('../../selectors/getIsOpen');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var visitorReceiveHandlers = exports.visitorReceiveHandlers = _defineProperty({}, ActionTypes.RECEIVED_INCOMING_MESSAGE, function (action, getState, dispatch) {
  var _action$payload = action.payload,
      channel = _action$payload.channel,
      message = _action$payload.message;

  var widgetIsOpen = (0, _getIsOpen.getIsOpen)(getState());
  var messageRole = (0, _commonMessageFormatGetters.getSenderType)(message);

  var threadIsActive = (0, _getActiveChannel.getActiveChannel)(getState()) === channel;

  if ((0, _messageTypeComparators.isConversationalMessage)(message) && (!widgetIsOpen || !threadIsActive) && messageRole !== _senderTypes.VISITOR) {
    dispatch((0, _hasNewUnseenMessage.hasNewUnseenMessage)({ channel: channel }));
  }

  dispatch((0, _addMessageToConversation.addMessageToConversation)({ channel: channel, message: message, threadIsActive: threadIsActive }));
});


//////////////////
// WEBPACK FOOTER
// ./js/pubsub/handlers/visitorReceiveHandlers.js
// module id = 856
// module chunks = 2 3